import get from 'lodash/get';
import * as apiActions from '@configuratorware/configurator-frontendgui/App/Reducers/Actions';
import { setVisible, setWorkInProgress } from '../Ui/Actions';
export const actionTypes = {
  SET_CONTAINER_ROWS_COLS: 'SET_CONTAINER_ROWS_COLS',
  SET_CONTAINER_FLOORS: 'SET_CONTAINER_FLOORS',
  RECEIVE_CONFIGURATION: 'CONFIGURATION_RECEIVE_CONFIGURATION',
  RECEIVE_SAVE_CONFIGURATION: 'CONFIGURATION_RECEIVE_SAVE_CONFIGURATION',
  REQUEST_ERROR: 'CONFIGURATION_REQUEST_ERROR',
  RESET_CODE: 'CONFIGURATION_RESET_CODE',
  RESET_ERROR: 'CONFIGURATION_RESET_ERROR',
  SET_LOAD_CODE: 'CONFIGURATION_SET_LOAD_CODE',
  SET_SELECTED_CONTAINER_ITEM: 'SET_SELECTED_CONTAINER_ITEM',
  UPDATE_SELECTED_CONTAINER_ITEM: 'UPDATE_SELECTED_CONTAINER_ITEM',
  SET_SELECTED_FLOOR: 'SET_SELECTED_FLOOR',
};

export const setContainerRowsCols = (rows, cols) => (dispatch) => {
  return dispatch({
    type: actionTypes.SET_CONTAINER_ROWS_COLS,
    rows,
    cols,
  });
};

export const setContainerFloors = (floors) => (dispatch) => {
  return dispatch({
    type: actionTypes.SET_CONTAINER_FLOORS,
    floors,
  });
};

export const createRequestError = (e) => ({
  type: actionTypes.REQUEST_ERROR,
  error: e,
});

export const resetError = () => ({
  type: actionTypes.RESET_ERROR,
});

export const loadConfiguration = (code) => async (dispatch) => {
  await dispatch(setWorkInProgress('loadConfiguration', true));
  return dispatch(
    apiActions.fetchData(`configuration/loadbyconfigurationcode/${code}`, receiveConfiguration)
  );
};

export const receiveConfiguration = (configuration) => async (dispatch) => {
  await dispatch(setVisible('loadConfiguration', false));
  await dispatch(setWorkInProgress('loadConfiguration', false));
  return dispatch({
    type: actionTypes.RECEIVE_CONFIGURATION,
    configuration,
  });
};

export const resetConfigurationCode = () => ({
  type: actionTypes.RESET_CODE,
});

export const saveConfiguration =
  (data, screenshot, configurationType, extraData = {}) =>
  async (dispatch, getState) => {
    const { configuration } = getState().configurator;
    const screenshots = {
      [configuration.item.identifier]: screenshot,
    };
    const configurationWithCustomData = {
      ...configuration,
      customdata: {
        ...configuration.customdata,
        ...data.customdata,
        ...extraData,
      },
      screenshots,
    };

    try {
      const response = await dispatch(
        apiActions.postDataAsync('configurations', {
          configurationtype: configurationType,
          configuration: configurationWithCustomData,
        })
      );
      const configuration = get(response, 'data', {});

      dispatch({
        type: actionTypes.RECEIVE_SAVE_CONFIGURATION,
        configuration,
      });
      return configuration;
    } catch (e) {
      dispatch(createRequestError(e));
    } finally {
      dispatch(setWorkInProgress('saveConfiguration', false));
    }
  };

export const setLoadCode = (loadCode = null) => ({
  type: actionTypes.SET_LOAD_CODE,
  loadCode,
});

export const createAndSendPdf = (data) => async (dispatch, getState) => {
  dispatch(setWorkInProgress('createAndSendPdf', true));
  const { configuration } = getState().configurator;
  const code = get(configuration, 'code');

  try {
    const response = await dispatch(apiActions.postDataAsync(`configurations/${code}/pdf`, data));

    const price = get(response, 'data.price', 0);
    const dataLayer = window.dataLayer;
    if (dataLayer) {
      dataLayer.push({
        event: 'Request-PDF',
        value: price,
      });
    }
    return response;
  } catch (e) {
    dispatch(createRequestError(e));
  } finally {
    dispatch(setWorkInProgress('createAndSendPdf', false));
  }
  return null;
};

export const setSelectedContainerItem = (containerItem: ContainerItem) => ({
  type: actionTypes.SET_SELECTED_CONTAINER_ITEM,
  containerItem,
});

export const updateSelectedContainerItem = (newContainerItem: ContainerItem) => ({
  type: actionTypes.UPDATE_SELECTED_CONTAINER_ITEM,
  newContainerItem,
});

export const setSelectedFloor = (floor: number) => ({
  type: actionTypes.SET_SELECTED_FLOOR,
  floor,
});
